<template>
  <v-flex>
    <v-row justify="center">
      <v-dialog
        :content-class="'margin-left-105'"
        :persistent="true"
        v-model="dialog"
      >
        <v-card>
          <v-card-title>
            <span class="blue--text headline">Lollicup Guests, we are open for takeout!</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col v-if="showAnnouncement">
                <span class="subtitle-1 red--text font-weight-bold">Announcement:</span>
                <span class="font-weight-bold">
                  Memorial Day (Monday, May 31, 2021) Hours: 12:00 P.M. - 6:00 P.M.
                </span>
              </v-col>
              <v-col v-else>
                <span class="font-weight-bold">
                  We are thankful that we can still provide our guests with the option to take out, as well as the
                  ability to order for delivery through
                  <a href="https://postmates.com/merchant/lollicup-1589-s-colorado-blvd" target="_blank">PostMates</a>!
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span>
                  As COVID-19 has greatly effected the food service industry, we will be tentatively adjusting our
                  hours of operation to the following:
                </span>
              </v-col>
            </v-row>
            <v-row v-for="(item) in dialogHoursOfOperation">
              <v-col class="py-0" cols="12" xs="4" sm="3" md="2">
                <div>
                  <span class="font-weight-bold">{{item.dayOfWeek}}</span>
                </div>
              </v-col>
              <v-col class="py-0" cols="12" xs="8" sm="9" md="10">
                <div>
                  <span>{{item.hours}}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text" @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-flex>
</template>

<script>
  export default {
    name: 'ModalLandingPopup',

    created() {
      this.dialog = true;
    },

    data() {
      return {
        dialog: false,
        dialogHoursOfOperation: [
          {
            dayOfWeek: 'Monday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Tuesday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Wednesday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Thursday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Friday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Saturday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Sunday',
            hours: '12:00 P.M. - 8:00 P.M.'
          }
        ],
        showAnnouncement: true
      };
    }
  };
</script>

<style>
  .v-dialog.margin-left-105 {
    margin: 16px 16px 16px 88px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal_landing_popup.vue